<template>
	<!--
		TODO @Simon: Dateiformat in API ausgeben und hier entsprechend anzeigen
	-->
	<div v-if="context">
		<nk-wrapper v-if="context.length < 20" spacing="lg">
			<nk-nav aria-label="Wegweiser Formulare">
				<nk-nav-item
					v-for="(formular, formulareIndex) in context"
					:key="formulareIndex"
					:link="formular.pfad"
					:prepend-icon="formular.link ? 'link' : 'download'"
					target="_blank"
					:title="formular.titel"
					:text="formular.link ? '' : 'PDF - Nicht barrierefrei'"
				/>
			</nk-nav>
		</nk-wrapper>

		<template v-else>
			<nk-wrapper
				v-for="(group, buchstabeIndex) in groups"
				:key="`buchstabe-${buchstabeIndex}`"
				spacing="lg"
			>
				<nk-accordion
					:title="group.buchstabe"
					title-size="lg"
					variant="boxed"
					open
				>
					<nk-nav aria-label="Wegweiser Formulare" variant="resources">
						<nk-nav-item
							v-for="(formular, formulareIndex) in group.formulare"
							:key="formulareIndex"
							:link="formular.pfad"
							:prepend-icon="formular.link ? 'link' : 'download'"
							target="_blank"
							:title="formular.titel"
							:text="formular.link ? '' : 'PDF - Nicht barrierefrei'"
						/>
					</nk-nav>
				</nk-accordion>
			</nk-wrapper>
		</template>
	</div>
</template>

<script>
import {groupBy, map} from 'lodash-es';
import TemplatesDefault from '../../mixins/templates-default';

export default {
	name: 'NkTemplateWegweiserFormulare',

	mixins: [TemplatesDefault],

	computed: {
		groups() {
			const result = this.context;
			return this.sortByLetters(result);
		},
	},

	methods: {
		sortByLetters(array) {
			const group = groupBy(array, o => o.titel[0].toUpperCase());

			return map(group, (value, key) => ({buchstabe: key, formulare: value}));
		},
	},
};
</script>
